import { withTranslation } from 'react-i18next';

import { compose } from 'recompose';

import DeniedMethodAdvice from 'components/orders/DeniedMethodAdvice/component';

const enhance = compose(withTranslation('PaymentData'));

export default enhance(DeniedMethodAdvice);
